import { InputElement } from "./InputElement";
import { DateFormat } from "../format/DateFormat";
/**
 * Input Datetime Local Element
 */
export class InputDatetimeLocalElement extends InputElement {
    /**
     * Constructor
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    constructor(htmlElement, bindData, context) {
        super(htmlElement, bindData, context);
        this.dateFormat = new DateFormat('yyyy-MM-ddTHH:mm');
    }
    /**
     * Sets element value
     * @param value
     */
    setValue(value) {
        if (value) {
            this.getHtmlElement().value = this.dateFormat.format(value);
        }
        else {
            this.getHtmlElement().value = '';
        }
    }
    /**
     * Gets element value
     */
    getValue() {
        let value = this.getHtmlElement().value;
        if (value) {
            return new Date(value).toISOString();
        }
        else {
            return null;
        }
    }
}
//# sourceMappingURL=InputDatetimeLocalElement.js.map